import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => (
  <div className="terms-container">
    <h2>📑 TÉRMINOS Y CONDICIONES DE USO</h2>
    <p><strong>Versión:</strong> agosto 2025<br />
    <strong>Última actualización:</strong> 7 de agosto de 2025</p>
    <ol>
      <li>
        <strong>IDENTIFICACIÓN</strong>
        Estas condiciones generales regulan el acceso y uso de la aplicación web Cookychat.com, propiedad de una persona física identificada como responsable del servicio, en fase de prueba previa a la constitución formal de una empresa.<br />
        Puedes contactar con el responsable en: <a href="mailto:cookychatapp@gmail.com">cookychatapp@gmail.com</a>
      </li>
      <li>
        <strong>OBJETO</strong>
        Cookychat es una aplicación web dirigida a mayores de 18 años, residente en España, que permite:<br />
        <ul>
          <li>Registrar un perfil con nombre, correo, sexo y preferencias culinarias.</li>
          <li>Interactuar con un asistente de inteligencia artificial.</li>
          <li>Compartir recetas y publicaciones con otros usuarios.</li>
          <li>Guardar contenido favorito y crear una lista de la compra.</li>
          <li>Recibir contenidos promocionales y publicidad.</li>
        </ul>
        El acceso y uso de esta aplicación implica la aceptación expresa de estos Términos y Condiciones.
      </li>
      <li>
        <strong>REGLAS DE USO</strong>
        El usuario se compromete a:
        <ul>
          <li>No publicar contenidos ofensivos, ilegales o que vulneren derechos de terceros.</li>
          <li>No utilizar la app para actividades ilícitas o fraudulentas.</li>
          <li>Respetar a otros usuarios en todo momento.</li>
        </ul>
        La app podrá suspender o eliminar cuentas que incumplan estas reglas.
      </li>
      <li>
        <strong>TRATAMIENTO DE DATOS PERSONALES</strong>
        El usuario acepta que sus datos e interacciones serán tratados conforme a la Política de Privacidad, con el objetivo de mejorar la experiencia y ofrecer contenidos relevantes, incluyendo la creación de audiencias genéricas para mostrar publicidad personalizada.<br />
        No se utilizarán los datos para elaborar perfiles individuales ni se cederán a terceros para su identificación.
      </li>
      <li>
        <strong>CONTENIDO PUBLICADO POR USUARIOS</strong>
        Al publicar contenido en Cookychat (ej. recetas, comentarios, imágenes), el usuario concede al responsable una licencia no exclusiva, gratuita, global y transferible para usar dicho contenido dentro de la aplicación.<br />
        El usuario declara ser titular de los derechos del contenido que publica.
      </li>
      <li>
        <strong>LIMITACIÓN DE RESPONSABILIDAD</strong>
        El uso de la app se realiza bajo la exclusiva responsabilidad del usuario. Cookychat no garantiza la continuidad del servicio ni la ausencia de errores o vulnerabilidades.<br />
        No se asume responsabilidad por:
        <ul>
          <li>Daños derivados del uso indebido de la app.</li>
          <li>Contenidos publicados por los usuarios.</li>
          <li>Fallos en servicios de terceros (Firebase, Algolia, OpenAI, etc.).</li>
        </ul>
      </li>
      <li>
        <strong>PROPIEDAD INTELECTUAL</strong>
        Todo el contenido, código, diseño e interfaz de la app son propiedad del responsable, salvo los contenidos generados por los usuarios o integraciones de terceros.<br />
        Está prohibido reproducir, distribuir o modificar elementos de la app sin autorización previa.
      </li>
      <li>
        <strong>MODIFICACIONES</strong>
        Estos Términos podrán ser modificados en cualquier momento. Las modificaciones se comunicarán dentro de la app o en cookychat.com.
      </li>
      <li>
        <strong>LEGISLACIÓN APLICABLE</strong>
        Estos Términos se rigen por la legislación española. Para cualquier conflicto, las partes se someten a los Juzgados y Tribunales del domicilio del responsable, salvo que la ley disponga lo contrario.
      </li>
    </ol>
  </div>
);

export default TermsAndConditions;